import { render } from "./HeaderChatbotsComponent.vue?vue&type=template&id=1c346ee9&scoped=true"
import script from "./HeaderChatbotsComponent.vue?vue&type=script&lang=js"
export * from "./HeaderChatbotsComponent.vue?vue&type=script&lang=js"

import "./HeaderChatbotsComponent.vue?vue&type=style&index=0&id=1c346ee9&scoped=true&lang=css"

import exportComponent from "/Users/ayarmots/MyDev/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c346ee9"]])

export default __exports__